// En BlogCarousel.js
import React, { useState } from "react";
import { Box, SimpleGrid, Button, Flex } from "@chakra-ui/react";
import BlogCard from "./BlogCard"; // Asegúrate de tener esta importación correcta

const BlogCarousel = ({ blogs }) => {
  const itemsPerPage = 4; // Ajusta esto según tus necesidades
  const [currentPage, setCurrentPage] = useState(0);
  const totalPages = Math.ceil(blogs.length / itemsPerPage);

  const startIndex = currentPage * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const currentBlogs = blogs.slice(startIndex, endIndex);

  const goToNextPage = () =>
    setCurrentPage((prev) => Math.min(prev + 1, totalPages - 1));
  const goToPreviousPage = () =>
    setCurrentPage((prev) => Math.max(prev - 1, 0));

  return (
    <Box>
      <div className="grid grid-cols-1 xl:grid-cols-2 gap-6">
        {currentBlogs.map((blog) => (
          <BlogCard
            key={blog.blogId}
            blog={blog}
          />
        ))}
      </div>
      <Flex mt="4" justifyContent="center" alignItems="center">
        <Button onClick={goToPreviousPage} isDisabled={currentPage === 0}>
          Anterior
        </Button>
        {/* Renderizar números de página aquí */}
        {Array.from({ length: totalPages }, (_, index) => (
          <Button
            key={index}
            mx="2" // Margen horizontal para separar los números de página
            onClick={() => setCurrentPage(index)}
            bg={currentPage === index ? "#90BCB5" : "gray.200"} // Usar #90BCB5 para la página activa
            color={currentPage === index ? "white" : "black"} // Cambia el color del texto para la página actual
            _hover={{
              bg: currentPage === index ? "#90BCB5" : "gray.300", // Mantener el color #90BCB5 al pasar el mouse sobre la página activa
            }}
            borderRadius="full" // Botones redondos
          >
            {index + 1}
          </Button>
        ))}
        <Button
          onClick={goToNextPage}
          isDisabled={currentPage === totalPages - 1}
        >
          Siguiente
        </Button>
      </Flex>
    </Box>
  );
};

export default BlogCarousel;
